import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class AnnualLeasingAmountError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('AnnualLeasingAmountError', ...args);
    }
}
export default AnnualLeasingAmountError;
